// extracted by mini-css-extract-plugin
export default {"strikeThrough":"strikeThrough__Y2ViZ","baseCreditPrice":"baseCreditPrice__ZjM2N","discountText":"discountText__MTU2N"};